export default function validatePassword(password, confirmPassword) {
  if (!password) {
    return 'Password required.'
  } else if (confirmPassword !== undefined && password !== confirmPassword) {
    return 'Passwords do not match.'
  } else return ''
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/validatePassword.js